import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FiltrosCustosService } from '../../../../filters/filtros-custos.service';
import { CustoService } from '../../../../services/custo.service';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Instancia } from '../../../../types/Instancia.type';
import { PeriodoLiberado } from '../../../../types/PeriodoLiberado.type';
import { RetornoCusto } from '../../../../types/RetornoCusto.type';

@Component({
  selector: 'app-custoretorno',
  templateUrl: './custoretorno.component.html',
  styleUrl: './custoretorno.component.css'
})
export class CustoretornoComponent {

  retornoCusto: RetornoCusto[] = []
  retornosSelecionados: RetornoCusto[] = []

  periodosLiberados: PeriodoLiberado[] = []
  periodoSelecionado!: PeriodoLiberado | undefined
  processosSelecionados!: string[];
  loading: boolean = false;
  loadingInteg: boolean = false;

  instancias: Instancia[] = [];
    instanciaSelecionada!: string;

  constructor(private filtrosCusto: FiltrosCustosService, private datePipe: DatePipe, private toastService: ToastService, private custoService: CustoService){}

  carregaPeriodos(event: any){
    console.log(event.value);
    this.retornosSelecionados = []

    this.custoService.getPeriodosLiberadosCustos(event.value).subscribe(
      {
        next: (data) => {
          this.periodosLiberados = data
          this.periodoSelecionado = undefined
        },
        error: (error) => {
          this.toastService.erro("Erro", "Erro: " + error.error)
        }
      }
    )
  }

  carregaDadosRetorno(){

    this.loading = true

    
    if(this.periodoSelecionado != undefined){
      this.custoService.getRetornoCusto(this.instanciaSelecionada, this.periodoSelecionado.dataFim).subscribe(
        {
          next: (value) => {
            this.retornosSelecionados = []
            this.retornoCusto = value
          },
          error: (error) => {
            this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message)
            
            this.loading = false
          },
          complete: () => {
            this.retornosSelecionados = []
            this.loading = false
          }
        }
      )
    }
  }

  sincronizar(){

    this.loading = true

    if(this.periodoSelecionado != undefined){
      this.custoService.postBuscarPims(this.instanciaSelecionada, this.periodoSelecionado.dataInicio, this.periodoSelecionado.dataFim).subscribe({
        next: (data) => {
          this.toastService.sucesso("OK","Solicitação realizada, aguarde a finalização do processamento")
          this.loading = false
          this.carregaDadosRetorno();
          this.retornosSelecionados = []
        },
        error: (error) => {
          console.log(error);
          this.toastService.erro("NOK","Erro: " + error.error.message)
          this.loading = false
          this.retornosSelecionados = []
        }
      })
    }
  }

  requisitaIntegracao(){

    if(this.retornosSelecionados.length == 0){
      this.toastService.info("","Necessário selecionar os registros à serem integrados")

    }else{
      this.loading = true;
      let ids = this.retornosSelecionados.map(m => m.id);
      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }
    
        this.custoService.postEnviarErp(corpo).subscribe({
          next: (data) => {
            this.toastService.sucesso("OK","Solicitação realizada, aguarde a finalização do processamento")
            this.carregaDadosRetorno()

            this.loading = false;
          },
          error: (error) => {
            console.log(error);
            this.toastService.erro("NOK","Erro: " + error.error.message)
            this.loading = false;
          }
        })
    
        console.log(corpo);
    
      }
    }


    reverter(){

      if(this.retornosSelecionados.length == 0){
        this.toastService.info("","Necessário selecionar os registros à serem revertidos")
  
      }else{
        this.loading = true;
        let ids = this.retornosSelecionados.map(m => m.id);
        let corpo = {
          ids: ids,
          usuario: localStorage.getItem("cdUsuarioErp")
        }
      
          this.custoService.postReverter(corpo).subscribe({
            next: (data) => {
              this.toastService.sucesso("OK","Solicitação realizada, aguarde a finalização do processamento")
              this.carregaDadosRetorno()
              this.loading = false;
            },
            error: (error) => {
              console.log(error);
              this.toastService.erro("NOK","Erro: " + error.error.message)
              this.loading = false;
            }
          })
      
          console.log(corpo);
        }
      }

      exportar(){

        if(this.retornosSelecionados.length == 0){
          this.toastService.info("","Necessário selecionar os registros à serem exportados")
    
        }else{

          this.loading = true;
          let ids = this.retornosSelecionados.map(m => m.id);
          let corpo = {
            ids: ids,
            usuario: localStorage.getItem("cdUsuarioErp")
          }
        
            this.custoService.exportar(corpo).subscribe(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a')
              a.href = url
              a.download = 'data.xlsx'
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);

              this.loading = false;
            });
        
            console.log(corpo);
          }
        }

}
